<template>
	<div class="video-box">
		<video :src="url" controls="controls" playsinline webkit-playsinline preload="auto" x5-playsinline=true x5-video-player-type="h5" @ended="onended"></video>
	</div>
</template>

<script>
	export default {
		name: "VideoBox",
		props: {
			url: {
				type: String,
				default () {
					return ''
				}
			}
		},
		data() {
			return {

			};
		},
		mounted() {},
		methods: {
      onended() {
        this.$emit("ended")
      }
    }
	};
</script>

<style scoped>
	.video-box {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.video-box video {
		width: 100%;
		height: 100%;
		object-fit: contain;
		background-color: #000000;
	}
</style>
